import React, { useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { useGetAggregators, useGetSenders } from "api/api-hooks/alert-fan-hooks";

const DevSandbox = () => {
  const [checked, setChecked] = useState<boolean>(false);
  const [selectedSenderAggregator, setSelectedSenderAggregator] = useState();
  const { data: aggregatorsData, error: aggregatorsError, isLoading: aggregatorsIsLoading } = useGetAggregators({
    enabled: !checked
  });

  const { data: sendersData, error: sendersError, isLoading: sendersIsLoading } = useGetSenders({
    enabled: checked});

  if (aggregatorsIsLoading || sendersIsLoading) {
    return <div>Loading...</div>;
  }

  if (aggregatorsError || sendersError) {
    return <div>Error loading data</div>;
  }

  const renderEditButton = (rowData: any) => {
    return (
      <Button
        className="p-button-secondary p-button-text"
        icon="pi pi-pencil"
        onClick={() => {
          setSelectedSenderAggregator(rowData);
        }}
      />
    );
  };
  console.log(selectedSenderAggregator)

  return (
    <div>
      <h1>Alerts Configuration</h1>
      <div className="flex flex-row gap-2">
        <div className="text-xl">Aggregators</div>
        <InputSwitch
          checked={checked}
          onChange={() => {
            setChecked(!checked);
          }}
          tooltip="Switch aggregators/senders"
        />
        <div className="text-xl">Senders</div>
      </div>
      <h2>{!checked ? "Aggregators" : "Senders"}</h2>
      <DataTable
        value={checked ? sendersData ?? [] : aggregatorsData ?? []}
      >
        <Column field="title" header="Title" />
        <Column header="Edit" body={(rowData) => renderEditButton(rowData)} />
      </DataTable>
    </div>
  );
};

export default DevSandbox;
